import { useState, useEffect, useCallback } from 'react';
import { fetchEmployees } from '../services/employeeService';

const useEmployeeList = () => {
  const [employees, setEmployees] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  // Memoize fetchEmployeesData using useCallback
  const fetchEmployeesData = useCallback(async (page = currentPage, rows = rowsPerPage) => {
    setIsLoading(true);
    try {
      const data = await fetchEmployees(page, rows);
      if (data && data.content) {
        setEmployees(data.content);
        setTotalPages(data.totalPages);
      } else {
        setEmployees([]);
        setTotalPages(1);
      }
    } catch (error) {
      console.error('Error fetching employees:', error);
      setEmployees([]);
    } finally {
      setIsLoading(false);
    }
  }, [currentPage, rowsPerPage]); // Dependencies are currentPage and rowsPerPage

  // Update useEffect to include fetchEmployeesData
  useEffect(() => {
    fetchEmployeesData();
  }, [fetchEmployeesData]); // Only re-run if fetchEmployeesData changes

  return {
    employees,
    isLoading,
    currentPage,
    rowsPerPage,
    totalPages,
    setCurrentPage,
    setRowsPerPage,
    fetchEmployees: fetchEmployeesData,
  };
};

export default useEmployeeList;
